module.exports = __webpack_public_path__ + "static/img/shape_16.0ce0d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shape_16.png
// module id = wBnZ
// module chunks = 0